import { getColors } from '@utils/StylesHelper'

function getColorStyle({ variant, color, theme }) {
  const colors = getColors(theme, color)
  const { lighter, light, dark, main, contrastText } = colors

  const focusStyle = {
    '&:focus-visible': {
      outline: `2px solid ${dark}`,
      outlineOffset: 2,
      ...(variant === 'text' && {
        backgroundColor: theme.palette.background.paper,
      }),
    },
  }

  switch (variant) {
    case 'combined':
    case 'contained':
      return {
        color: contrastText,
        backgroundColor: main,
        '&:hover': {
          backgroundColor: light,
        },
        ...focusStyle,
      }
    case 'outlined':
      return {
        borderColor: main,
        '&:hover': {
          backgroundColor: lighter,
          borderColor: light,
        },
        ...focusStyle,
      }
    case 'text':
    default:
      return {
        color: main,
        '&:hover': {
          backgroundColor: main,
          color: lighter,
        },
        ...focusStyle,
      }
  }
}

const COLORS = ['primary', 'secondary', 'error', 'success', 'info', 'warning']

function selectedVariantForColor({ variant, color, theme }) {
  return {
    props: { variant, color },
    style: {
      '&.Mui-selected': getColorStyle({ variant, color, theme }),
    },
  }
}

export default function PaginationItem(theme) {
  return {
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: `2px solid ${theme.palette.secondary.dark}`,
            outlineOffset: 2,
          },
          variants: [
            {
              props: { variant: 'text' },
              style: {
                '&.Mui-selected': {
                  backgroundColor: 'transparent',
                  fontSize: '1rem',
                  fontWeight: 500,
                },
              },
            },
            {
              props: { variant: 'outlined' },
              style: {
                borderColor: theme.palette.divider,
                '&.Mui-selected': { backgroundColor: 'transparent' },
              },
            },
            {
              props: { variant: 'combined' },
              style: {
                border: '1px solid',
                borderColor: theme.palette.divider,
                '&.MuiPaginationItem-ellipsis': { border: 'none' },
              },
            },
            ...['text', 'contained', 'outlined', 'combined'].flatMap((variant) =>
              COLORS.map((color) => selectedVariantForColor({ variant, color, theme }))
            ),
          ],
        },
      },
    },
  }
}
